"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _jobLog = require("_a/admin/job/job-log");
var _message = require("_l/message");
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'job-log-manage',
  components: {
    TablePage: _tablePage.default
  },
  props: {
    job: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      url: 'monitor/jobLog/page',
      columns: [{
        label: '任务名称',
        prop: 'jobName'
      }, {
        label: '任务组名',
        slot: 'jobGroup'
      }, {
        label: '调用目标字符串',
        prop: 'invokeTarget'
      }, {
        label: '日志信息',
        prop: 'jobMessage'
      }, {
        label: '执行状态',
        slot: 'jobStatus'
      }, {
        label: '异常信息',
        prop: 'exceptionInfo'
      }, {
        label: '操作',
        slot: 'action'
      }],
      queryParams: {},
      dialogShow: false,
      delBtnDisabled: true,
      dialogTitle: '添加调度日志',
      form: {},
      jobStatusOptionList: [],
      jobGroupStatusOptionList: [],
      executionDate: []
    };
  },
  watch: {
    executionDate: function executionDate(val, oldVal) {
      this.queryParams.beginDate = val[0];
      this.queryParams.endDate = val[1];
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 修改弹出框
     * @param row
     */
    detail: function detail(row) {
      this.form = _objectSpread({}, row);
      this.dialogTitle = '调度日志详细';
      this.dialogShow = true;
    },
    /**
     * 点击每一行的checkbox
     */
    selectVal: function selectVal(ids) {
      this.ids = ids.map(function (val) {
        return val['id'];
      });
      this.delBtnDisabled = !this.ids.length;
    },
    /**
     * 批量删除
     */
    removeBatch: function removeBatch() {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _jobLog.deleteBatchJobLogById)(_this.ids).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          _this.refresh();
        });
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this2 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _jobLog.deleteJobLogById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this2.refresh();
        });
      });
    },
    clearLog: function clearLog() {
      var _this3 = this;
      (0, _jobLog.cleanJobLog)().then(function (res) {
        if (res.data) {
          _this3.$message.success('操作成功');
        } else {
          _this3.$message.error('操作失败');
        }
        _this3.refresh();
      });
    }
  }),
  created: function created() {
    this.queryParams.jobName = this.job.jobName;
    this.queryParams.jobGroup = this.job.jobGroup;
  },
  mounted: function mounted() {
    var _this4 = this;
    this.getDictListByType('job_status').then(function (res) {
      _this4.jobStatusOptionList = res;
    });
    this.getDictListByType('job_group').then(function (res) {
      _this4.jobGroupStatusOptionList = res;
    });
  }
};